import {
  Content,
  Header,
  Item,
  Root,
  Trigger,
} from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "lucide-react";
import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type AccordionProps = ComponentProps<typeof Root>;
type AccordionItemProps = ComponentProps<typeof Item>;
type AccordionTriggerProps = ComponentProps<typeof Trigger>;
type AccordionContentProps = ComponentProps<typeof Content>;

export const Accordion: FC<AccordionProps> = (props) => (
  <Root data-slot="accordion" {...props} />
);

export const AccordionItem: FC<AccordionItemProps> = ({
  className,
  ...props
}) => (
  <Item
    data-slot="accordion-item"
    className={cn("border-b last:border-b-0", className)}
    {...props}
  />
);

export const AccordionTrigger: FC<AccordionTriggerProps> = ({
  className,
  children,
  ...props
}) => (
  <Header className="flex">
    <Trigger
      data-slot="accordion-trigger"
      className={cn(
        "focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        className,
      )}
      {...props}
    >
      {children}
      <ChevronDownIcon className="text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" />
    </Trigger>
  </Header>
);

export const AccordionContent: FC<AccordionContentProps> = ({
  className,
  children,
  ...props
}) => (
  <Content
    data-slot="accordion-content"
    className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm"
    {...props}
  >
    <div className={cn("pt-0 pb-4", className)}>{children}</div>
  </Content>
);
